import { rem } from 'polished';
import styled from 'styled-components';

import { remify } from '../../helpers';
import { IStyledHeadingProps } from './Heading.types';

export const StyledHeading = styled.h1<IStyledHeadingProps>`
  margin: ${({ margin }) => (margin ? remify(margin) : `0 0 1.25em 0`)};
  letter-spacing: ${({ charSpacing }) => charSpacing && rem(charSpacing)};
  /* color: lightcoral; */
  color: ${({ theme, user, variant }) => {
    if (user) {
      return theme.colors[user].main;
    } else if (variant && variant === 'secondary') {
      return theme.colors.cross.black;
    } else {
      return theme.colors.cross.deepBlu;
    }
  }};
  font-weight: 700;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    font-size: ${({ sm }) => (sm.substr(-2) === 'px' ? rem(sm) : sm)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    font-size: ${({ md }) => (md.substr(-2) === 'px' ? rem(md) : md)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    font-size: ${({ lg }) => (lg.substr(-2) === 'px' ? rem(lg) : lg)};
  }
  line-height: 1.25em;

  > span {
    display: inline-block;
    font-style: normal;
    background: ${({ theme }) => theme.colors.gradients.main};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    box-decoration-break: clone;
  }
`;
